import { render } from "./ConfirmComponent.vue?vue&type=template&id=93c63fee&scoped=true"
import script from "./ConfirmComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmComponent.vue?vue&type=script&lang=js"

import "./ConfirmComponent.vue?vue&type=style&index=0&id=93c63fee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93c63fee"]])

export default __exports__